import React from 'react'
import { reformatDashedDate } from './../../utils/js/time_helpers'

import './Last5.scss'
import { getTeamLogo } from '../../utils/js/shared_helpers'

const Last5 = ({ data, containerClass, allTeams, sport, draw }) => {
    const team_id = data.id
    const recent_games =
        data.hasOwnProperty('recent_games') && data.recent_games?.constructor === Array
            ? data.recent_games
            : ''

    return (
        <div className={`${containerClass}`}>
            {[...Array(5)].map((_, i) => {
                let game = recent_games[i] !== undefined ? recent_games[i] : null

                if (!game) {
                    return <div className="dot default" key={i} />
                }

                let home_team_id = null
                let visiting_team_id = null

                // swap home/visiting if sport is soccer
                if (sport === 'soccer') {
                    home_team_id = game.visiting_team_id || game.visiting_team
                    visiting_team_id = game.home_team_id || game.home_team
                } else {
                    home_team_id = game.home_team_id || game.home_team
                    visiting_team_id = game.visiting_team_id || game.visiting_team
                }

                if (home_team_id === team_id || visiting_team_id === team_id) {
                    let color = ''
                    let status_text = ''
                    let visiting_team = allTeams.filter(team => team.id === visiting_team_id)
                    let home_team = allTeams.filter(team => team.id === home_team_id)
                    let visiting_logo =
                        visiting_team[0] !== undefined
                            ? getTeamLogo(visiting_team[0], false, 'image_url_90')
                            : ''
                    let home_logo =
                        home_team[0] !== undefined
                            ? getTeamLogo(home_team[0], false, 'image_url_90')
                            : ''

                    let home_team_score = 0
                    let visiting_team_score = 0

                    if (sport === 'soccer') {
                        home_team_score = game.visiting_team_score
                        visiting_team_score = game.home_team_score
                    } else {
                        home_team_score = game.home_team_score
                        visiting_team_score = game.visiting_team_score
                    }

                    if (
                        (home_team_id === team_id && home_team_score < visiting_team_score) ||
                        (visiting_team_id === team_id && home_team_score > visiting_team_score)
                    ) {
                        if (game.overtime) {
                            color = 'otred'
                            status_text = 'OT Loss'
                        } else {
                            color = 'red'
                            status_text = 'Loss'
                        }
                    } else if (
                        (home_team_id === team_id && home_team_score > visiting_team_score) ||
                        (visiting_team_id === team_id && home_team_score < visiting_team_score)
                    ) {
                        color = 'blue'
                        status_text = 'Win'
                    } else if (
                        (home_team_id === team_id && home_team_score === visiting_team_score) ||
                        (visiting_team_id === team_id && home_team_score === visiting_team_score)
                    ) {
                        color = 'otred'
                        status_text = draw ? 'Draw' : 'Tie'
                    }

                    return (
                        <div
                            className={`dot ${color} active`}
                            key={
                                game?.game_id.toString() +
                                visiting_team_score?.toString() +
                                home_team_score?.toString() +
                                game?.game_date
                            }
                        >
                            <div className="game_pop_tag">
                                <div className="game_status_bar">
                                    <div className={`win_loss ${color}`}>{status_text}</div>
                                    <div>-</div>
                                    <div className="game_date">{reformatDashedDate(game.date)}</div>
                                </div>
                                <div className="score_status_bar">
                                    <div className="visiting">
                                        <div className="logo">
                                            {visiting_logo && (
                                                <img src={visiting_logo} alt="VT Logo" />
                                            )}
                                        </div>
                                        <div className="score">{visiting_team_score}</div>
                                    </div>
                                    <div className="seperator">|</div>
                                    <div className="home">
                                        <div className="score">{home_team_score}</div>
                                        <div className="logo">
                                            {home_logo && <img src={home_logo} alt="HT Logo" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    return ''
                }
            })}
        </div>
    )
}

export default Last5
